import { Link } from "react-router-dom";
import { MessageCircle, Mail } from "lucide-react";
import { BRAND, WHATSAPP_URL, MAILTO } from "../lib/site";

const COLS = [
  {
    title: "Shop",
    links: [
      ["Shop All", "#featured"],
      ["Wall Mounted", "#categories"],
      ["Floor Mounted", "#categories"],
      ["How It Works", "#how"],
    ],
  },
  {
    title: "Support",
    links: [
      ["Track Order", "/orders"],
      ["Installation", "#installation"],
      ["FAQ", "#faq"],
      ["Size Guide", "#size-guide"],
      ["Contact", MAILTO],
    ],
  },
  {
    title: "Policies",
    links: [
      ["Shipping", "#faq"],
      ["Returns", "#faq"],
      ["Installation Terms", "#installation"],
      ["Privacy Policy", "#faq"],
      ["Terms", "#faq"],
    ],
  },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ivory pt-20 md:pt-24">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12">
      <div className="grid lg:grid-cols-12 gap-12 pb-16">
        <div className="lg:col-span-5">
          <span className="font-serif text-3xl">
            <span className="font-medium text-charcoal">Bath</span>
            <span className="font-light italic text-taupe">Lane</span>
          </span>
          <p className="mt-5 max-w-sm text-charcoal/65 text-sm leading-relaxed">
            Premium bathroom vanity buying, made simple. Curated wall mounted
            and floor mounted vanities with size guidance, transparent dispatch
            and Jaipur installation support.
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <a
              href={WHATSAPP_URL()}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp"
              className="inline-flex items-center gap-2 rounded-full border border-charcoal px-5 py-2.5 text-sm text-charcoal btn-fill hover:text-charcoal transition-colors duration-500"
            >
              <MessageCircle size={15} strokeWidth={1.5} /> {BRAND.phoneDisplay}
            </a>
            <a
              href={MAILTO}
              data-testid="footer-email"
              className="inline-flex items-center gap-2 rounded-full border border-beige px-5 py-2.5 text-sm text-charcoal hover:border-charcoal transition-colors duration-300"
            >
              <Mail size={15} strokeWidth={1.5} /> {BRAND.email}
            </a>
          </div>
        </div>

        {COLS.map((col) => (
          <div key={col.title} className="lg:col-span-2">
            <h4 className="eyebrow text-taupe mb-5">{col.title}</h4>
            <ul className="space-y-3">
              {col.links.map(([label, href]) => (
                <li key={label}>
                  {href.startsWith("/") ? (
                    <Link
                      to={href}
                      className="text-sm text-charcoal/70 hover:text-charcoal link-sweep"
                    >
                      {label}
                    </Link>
                  ) : (
                    <a
                      href={href}
                      className="text-sm text-charcoal/70 hover:text-charcoal link-sweep"
                    >
                      {label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

    </div>

    {/* Oversized wordmark */}
    <div className="overflow-hidden pb-12">
      <p className="font-serif font-light text-charcoal/[0.06] text-[22vw] leading-[0.8] text-center tracking-tighter select-none -mb-[2vw]">
        BathLane
      </p>
    </div>

    <div className="border-t border-beige">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-8 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-xs text-charcoal/50">© 2026 BathLane. All rights reserved.</p>
        <p className="text-xs text-charcoal/50">Vanity specialists · Jaipur, India</p>
      </div>
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 pb-8">
        <p className="text-center text-xs text-charcoal/45">
          Ninety One Processing Units Private Limited
        </p>
        <p className="text-center text-xs text-charcoal/45 mt-1">
          Registered Office: H. No. 47, Near Goshala Agewa Road, Jaitaran
        </p>
      </div>
    </div>
  </footer>
);
